// src/components/BGP/request/request.ts
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

export function getAuth0Users(token: string, tenantId: number) {
    const url =
        tenantId === 0
            ? `${API_V1_URL}/auth0/users/list/`
            : `${API_V1_URL}/auth0/users/list/?tenantId=${tenantId}`;
    return axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getUserId(token: string, id: string) {
    return axios.get(`${API_V1_URL}/auth0/users/get/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getUserIdglobal(token: string, id: string, tenant: number) {
    return axios.get(`${API_V1_URL}/auth0/users/get/${id}?tenantId=${tenant}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getroles(token: string) {
    return axios.get(`${API_V1_URL}/rol/`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getrolesglobal(token: string, tenant: number) {
    return axios.get(`${API_V1_URL}/rol/?tenantId=${tenant}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function getmyuser(token: string) {
    return axios.get(`${API_V1_URL}/auth0/users/get/me`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}
